/* eslint-disable no-undef */
import { LitElement, html, css } from 'lit'
import { ifDefined } from 'lit/directives/if-defined.js'
import { shopifyCart } from '../../api/cart'
import { centsToDollars, resizeImageSrc } from '../../lib/utils'
import { get } from '../../lib/ajax'
import buttonPrimary from './styles/button-primary.shared.css.js'
import upsells from './styles/upsells.shared.css.js'
import $ from '../../lib/quantdom'
import './free-shipping-progress'

export class CartDrawer extends LitElement {
  static styles = [
    css`
      :host {
        width: 100%;
        height: 100%;
      }

      * {
        font-family: 'Beatrice', sans-serif;
      }

      h3.cart-drawer_title {
        margin: 0 auto;
        font-size: 20px;
        font-weight: 400;
        margin: 0 10px 0 0;
        line-height: 1;
      }

      button {
        cursor: pointer;
      }

      .relative {
        position: relative;
      }

      .flex {
        display: flex;
      }

      .hidden {
        display: none;
      }

      .flex-col {
        flex-direction: column;
      }

      .justify-between {
        justify-content: space-between;
      }

      .items-center {
        align-items: center;
      }

      .flex-1 {
        flex: 1 1 0%;
      }

      .font-bold {
        font-weight: 700;
      }

      .margin-t-xs {
        margin-top: 8px;
      }

      .margin-t-sm {
        margin-top: 10px;
      }

      .mt-3 {
        margin-top: 12px;
      }

      .mt-4 {
        margin-top: 16px;
      }

      .mt-5 {
        margin-top: 20px;
      }

      .margin-b-xs {
        margin-bottom: 3px;
      }

      .text-center {
        text-align: center;
      }

      header {
        padding: 20px 20px 0;
      }

      free-shipping-progress {
        padding: 16px 0;
        border-bottom: 1px solid #e4e4e7;
      }

      .empty-cart .empty-cart_details button,
      button#checkout {
        font-size: 14px;
      }

      .cart-drawer_header {
        padding: 16px 0 0 0;
      }

      .cart-drawer_header-details {
        border-bottom: 1px solid #e4e4e7;
        display: flex;
        align-items: flex-end;
        padding: 0 20px 16px 20px;
      }

      @media (max-width: 430px) {
        header {
          padding: 20px 0 0 0;
        }
      }

      .cart-drawer_cart-count {
        color: #6e6e73;
        font-size: 14px;
        margin: 0;
      }

      .add-gift-note-wrapper {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e4e4e7;
        padding: 10px 20px;
        font-size: 12px;
        color: #231f20;
      }

      .add-gift-note-wrapper side-drawer-btn,
      .add-gift-note-wrapper side-drawer-btn > * {
        color: #231f20 !important;
        font-size: 12px;
      }

      .add-gift-note-wrapper[gift-note-active] side-drawer-btn {
        border-bottom: 1px solid #231f20;
      }

      .bundle {
        margin: 8px 0 0 0;
        font-size: 12px;
        font-weight: bold;
      }

      .cart-drawer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
      }

      .cart-item .right {
        width: 100%;
      }

      .cart-item-delete {
        min-width: 116px;
        width: 100%;
        scroll-snap-align: end;
      }

      .cart-item-subscription {
        margin-bottom: 6px;
        font-size: 10px;
        color: #978f90;
        display: flex;
        align-items: center;
      }

      @media (min-width: 431px) {
        .cart-item {
          width: 100%;
        }
      }

      .cart-item .cart-item_border {
        padding: 16px 0;
        gap: 10px;
      }

      .cart-drawer .cart-item:not(:last-child) .cart-item_border {
        border-bottom: 1px solid #e4e4e7;
      }
      /* Main Cart Page Styles */
      .cart-drawer[main='true'] .cart-item {
        width: 100%;
      }

      .cart-drawer[main='true'] .cart-item-delete {
        display: none;
      }

      .cart-item > .right {
        margin-left: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .cart-item img.cart-item_image {
        width: 100%;
        height: 85px;
        object-fit: contain;
        max-width: 100px;
        margin: 0 auto;
        background-color: #f5f4f7;
      }

      .cart-drawer {
        font-size: 14px;
      }

      .cart-drawer_products.is-empty {
        height: 100%;
      }

      .cart-drawer .cart-drawer_products-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow-y: scroll;
        border-bottom: 1px solid #e4e4e7;
      }

      .cart-drawer .cart-drawer_products-line-container {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .cart-drawer .cart-drawer_products {
        padding: 0 20px;
        list-style-type: none;
        margin: 0;
        background: #fff;
      }

      .cart-drawer_bottom {
        padding: 16px 20px;
        background: #fff;
      }

      .cart-drawer_bottom ul {
        padding-inline-start: 0;
      }

      button.close-btn {
        background: none;
        border: none;
        cursor: pointer;
        position: absolute;
        right: 0px;
        top: 5px;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type='number'] {
        -moz-appearance: textfield;
      }

      .quantity-selector {
        width: 100%;
        background-color: #f5f4f4;
        padding: 0 5px;
      }

      .quantity-selector input,
      .quantity-selector button {
        background: none;
        border: none;
        text-align: center;
        padding: 0;
      }

      button.remove-btn {
        background: #f5f4f4;
        border: none;
        line-height: 1;
        padding: 0 7.5px;
        margin-left: 5px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .remove-btn_icon {
        width: 8px;
      }

      .quantity-selector > button,
      .quantity-selector > input[type='number']:disabled,
      button.remove-btn {
        color: #231f20;
        -webkit-text-fill-color: #231f20;
        opacity: 1; /* required on iOS */
        width: 100%;
        max-width: 26px;
        font-size: 14px;
      }

      .left {
        display: flex;
        flex-direction: column;
        gap: 10px;
        min-width: 97px;
      }

      .loading-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: white;
      }

      .cart-drawer[loading='true'] .cart-drawer_products,
      .cart-drawer[loading='true'] .cart-drawer_upsells,
      .cart-drawer[loading='true'] .cart-drawer_products-line-container {
        display: none;
      }

      .cart-drawer[loading='false'] .loading-container {
        display: none;
      }

      h4,
      h5 {
        margin: 0;
        font-size: 16px;
      }

      .order-total {
        font-weight: 700;
        font-size: 14px;
      }

      .order-total h4 {
        font-size: 14px;
      }

      .empty-cart {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        padding: 0 15px;
      }

      .empty-cart_details {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 330px;
        margin: 0 auto 50% auto;
      }

      a {
        text-decoration: none;
      }

      .empty-cart_text {
        text-align: center;
        font-size: 16px;
        margin-top: 25px;
        margin-bottom: 25px;
        line-height: 1.5;
      }

      .empty-cart_image {
        height: auto;
        width: 100%;
        max-width: 330px;
        margin: 0 auto;
        position: relative;
        top: 30px;
      }

      .gap-1 {
        gap: 4px;
      }

      .title {
        color: #231f20;
        font-family: Beatrice;
        font-size: 14px;
        font-weight: 700;
        line-height: 132%;
        margin: 0px;
      }
      .type {
        color: #231f20;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        text-transform: capitalize;
      }

      .compare-price {
        color: #6e6e73;
        font-size: 14px;
      }

      .variant-title {
        color: #6e6e73;
        font-size: 14px;
        display: flex;
      }
      /* Main Cart/Cart Page Styles */
      .cart-drawer[main='true'] .loading-container {
        height: auto;
      }

      .cart-drawer[main='true'] .continue-shopping {
        margin-top: 15px;
        text-decoration: underline;
        text-align: center;
      }
      .cart-drawer[main='true'] .continue-shopping a {
        color: #000;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products {
        width: 100%;
        overflow-y: hidden;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_details {
        display: none;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty {
        margin-bottom: -64px;
      }

      .cart-drawer[main='true'] {
        border: none;
      }

      @media (min-width: 800px) {
        .cart-drawer[main='true'] .cart-drawer_body.is-empty {
          margin-bottom: -80px;
        }

        .cart-drawer[main='true'] {
          max-width: 1080px;
          margin: 0 auto;
          border: none;
        }

        .cart-drawer[main='true'] .loading-container {
          margin-right: 45px;
        }

        .cart-drawer[main='true'] .loading-container {
          width: 70%;
          height: auto;
        }

        .cart-drawer[main='true'] header {
          padding: 0;
          margin: 0 0 15px 0;
        }

        .cart-drawer[main='true'] .cart-drawer_body:not(.is-empty) .cart-scroll-blur {
          width: calc(100% - 35px);
          height: 60px;
          background-image: linear-gradient(180deg, transparent 18%, #fff 75%);
          position: absolute;
          bottom: 0px;
        }

        .cart-drawer[main='true'] .empty-cart {
          flex-direction: row;
          align-items: center;
          max-width: 950px;
          margin: 0 auto;
        }

        .cart-drawer[main='true'] .cart-drawer_body {
          display: flex;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_products {
          width: 100%;
          height: auto;
          max-height: 306px;
          padding: 0 35px 0 0;
          overflow: auto;
        }

        .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products {
          max-height: 100%;
        }

        .cart-drawer[main='true'] .cart-drawer_products .cart-item:last-child {
          margin-bottom: 25px;
        }

        .cart-drawer[main='true'] .cart-drawer_products-wrap {
          margin: 0 10px 0 0;
          width: 65%;
        }

        .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products-wrap {
          margin: 0;
          width: 100%;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_details {
          width: 35%;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_bottom {
          width: 100%;
          border-radius: 10px;
          padding: 20px 20px 30px 20px;
        }
      }

      .cart-drawer[main='true'] header {
        padding: 0;
      }

      .discount-code-form {
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 16px;
        margin-bottom: 16px;
      }

      .discount-code-form > div {
        border-radius: 0;
        width: 60%;
        padding: 0;
        border: 1px solid #bfbbbb;
        font-size: 16px;
        margin: 0;
      }

      .discount-code-form > div > input {
        font-size: 16px;
        width: calc(100% - 30px);
        padding: 10px 15px;
        border: none;
      }
      .discount-code-form > div > label {
        top: 0px;
        left: 15px;
        position: absolute;
        font-size: 0.75rem;
        line-height: 1rem;
        color: #6e6e73;
      }

      .discount-code-form > div > input:placeholder-shown ~ label {
        visibility: hidden;
      }

      .discount-code-form > input {
        padding: 10px 15px;
        border: 1px solid #bfbbbb;
        border-radius: 0;
        font-size: 16px;
      }

      .discount-code-form > button {
        background: #231f20;
        color: #fff;
        font-size: 16px;
        width: 40%;
        border: none;
        align-items: center;
        font-weight: 500;
        justify-content: center;
        display: flex;
        transition: background 0.3s ease-in-out;
      }

      .discount-code-form > button:hover {
        background: #070606;
      }

      .discount-code-form > button > .apply-text {
        display: block;
      }

      .discount-code-form > button > .applied-text {
        display: none;
      }

      .discount-code-form.discount-applied > button > .apply-text {
        display: none;
      }

      .discount-code-form.discount-applied > button > .applied-text {
        display: block;
      }

      .discount-code-form > button svg {
        display: none;
      }

      .discount-code-form > button[data-loading='true'] .applied-text,
      .discount-code-form > button[data-loading='true'] .apply-text {
        display: none;
      }

      .discount-code-form > button[data-loading='true'] svg {
        display: block;
        width: 20px;
        height: 20px;
      }

      .discount-code-form.discount-applied > input {
        color: #888;
        opacity: 1;
      }

      .discount-code-form > input.input-active {
        text-transform: uppercase;
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
      }
    `,
    buttonPrimary,
    upsells,
  ]

  static properties = {
    count: { type: Number },
    cartItems: { type: Array },
    upsells: { type: Array },
    hide: { type: Boolean },
    main: { type: Boolean },
    subtotal: { type: Number },
    discount: { type: String },
    discountLoading: { type: Boolean },
    isGiftNote: { type: Boolean, attribute: 'gift-note', reflect: true },
  }

  constructor() {
    super()
    this.url = new URL(window.location)
    this.assets = this.url.host === '127.0.0.1:9292' ? `${this.url.origin}/assets/` : window.HU_Store.asset_url
    this.store = window.HU_Store
    this.subtotal = 0
    this.params = this.url.searchParams

    if (this.params.get('discount_code')) {
      localStorage.setItem('_discount_code', this.params.get('discount_code').toUpperCase())
    }
    this.discountCode = localStorage.getItem('_discount_code') ?? '' // need to check for session storage
  }

  _setCart() {
    return new Promise(async (resolve) => {
      shopifyCart.fetchNewCart().then(async (res) => {
        console.log(res)
        this.ogSubtotal = res.total_price
        this.ogTotalSavings = res.total_savings
        this.hasSubscription = res.has_subscription
        this.cartToken = res.token
        this.count = res.item_count
        this.cartItems = [...res.items].reverse()
        if (this.discountCode && this.count > 0 && this.discountCodeEnabled) {
          let res = false
          if (this.hasSubscription) {
            res = await this._getDiscount(this.discountCode)
          } else {
            res = await this.applyDiscount(this.discountCode)
          }
          this._setDiscountCodeInfo(res)
        } else {
          this.subtotal = centsToDollars(res.total_price)
          this.totalSavings = centsToDollars(res.total_savings)
        }

        this.totalCompare = centsToDollars(res.total_price + res.total_savings)
        this.itemsText = this.count === 1 ? 'item' : 'items'
        window.MicroBus.emit('count-change', { count: this.count })
        if (this.main) {
          const el = $(this)
          const initialLoader = $('.js-initial-loading')
          initialLoader.hide()
          initialLoader.attr('aria-hidden', 'true')
          el.removeClass('hidden')
        }
        this.upsells = this.count > 0 ? await this._getSingleProductRecommendation(this.cartItems[0]?.product_id) : []
        this.isGiftNote = res.note !== null && res.note !== ''
        if (this.isGiftNote) {
          $('.js-gift-note-textarea').val(res.note)
          $('.js-cart-gift-note-form').attr('data-note-exists', 'true')
        } else {
          $('.js-gift-note-textarea').val('')
          $('.js-cart-gift-note-form').attr('data-note-exists', 'false')
        }
        console.log('gift note', this.isGiftNote)
        resolve(res)
      })
    })
  }

  async _getSingleProductRecommendation(productId) {
    const cartIds = this.cartItems.map((item) => item.product_id)
    const upsellIds = this.upsells.map((item) => item.id)
    const hasMatch = cartIds.some((el) => upsellIds.indexOf(el) > -1)
    if (this.upsells.length == 0 || hasMatch == true) {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=6`)
      const { products } = await res.json()
      if (!products) return this.upsells
      let uniqueRecs = products.reduce((prev, curr) => {
        return prev.some((el) => (el.id === curr.id && cartIds.indexOf(el.id) == -1) || el.available == false)
          ? prev
          : [...prev, curr]
      }, [])
      return uniqueRecs.slice(0, 4)
    } else {
      return this.upsells
    }
  }

  async _getProductRecommendations() {
    let promises = []
    const cartIds = this.cartItems.map((item) => item.product_id)
    this.cartItems.forEach(({ product_id }) => {
      promises.push(fetch(`/recommendations/products.json?product_id=${product_id}&limit=4`).then((res) => res.json()))
    })
    const recs = await Promise.all(
      promises.map(async (res) => {
        const { products } = await res
        return products
      })
    )
    const temp = recs.reduce((prev, curr) => [...prev, ...curr], [])
    const every_nth = (arr, nth) => arr.filter((e, i) => i % nth === nth - 1)
    let uniqueRecs = temp.reduce((prev, curr) => {
      return prev.some((el) => (el.id === curr.id && cartIds.indexOf(el.id) == -1) || el.available == false)
        ? prev
        : [...prev, curr]
    }, [])
    uniqueRecs = every_nth(uniqueRecs, Math.round(uniqueRecs.length / 4))
    return uniqueRecs
  }

  connectedCallback() {
    super.connectedCallback()
    const params = new URLSearchParams(window.location.search)

    this.count = 0
    this.cartItems = []
    this.upsells = []
    this.hide = true
    this.main = this.main ?? false
    this.totalSavings = 0
    this.hasSubscription = false
    this.itemsText = this.count === 1 ? 'item' : 'items'
    this.store = window.HU_Store
    this.settings = this.store.settings
    this.empty_cart = this.settings.empty_cart
    this.discountCodeEnabled = this.settings.cart_discount_enabled
    this.giftNoteEnabled = this.settings.cart_gift_note_enabled
    this.discountLoading = false
    this.bundleMinimum = 3
    this._setCart() //fetch cart data and build cart html

    window.MicroBus.on('cart:add', (e) => {
      this._setLoadingState(true)
      if (e.detail.variant_id) {
        this._setLoadingState(true)
        let quantity = e.detail?.quantity ?? 1
        shopifyCart
          .add(quantity, e.detail?.variant_id, e.detail?.properties)
          .then(() => {
            this._setCart().then(() => {
              this._setLoadingState(false)
            })
          })
          .catch(() => {
            this._setLoadingState(false)
          })
      } else {
        // get rd of this once we do pdp page
        this._setCart()
          .then(() => {
            this._setLoadingState(false)
          })
          .catch(() => {
            this._setLoadingState(false)
          })
      }
    })

    window.MicroBus.on('side-cart:toggle', (e) => {
      setTimeout(() => {
        const el = this.shadowRoot.querySelector('.side-cart-upsell-products')
        if (el) el.scrollLeft = 0
      }, 200)
    })

    window.MicroBus.on('cart:change-quantity', async (e) => {
      const { key, quantity, item } = e.detail
      const bundleId = item.properties?.bundle_id
      const bundleItems = bundleId ? this.cartItems.filter((el) => el.properties?.bundle_id === bundleId) : []
      const totalBundleQuantity = bundleItems.reduce((acc, el) => acc + el.quantity, 0)
      const quantityDiff = quantity < item.quantity ? item.quantity - quantity : 0
      const bundleQuantityAfterChange = totalBundleQuantity - quantityDiff

      if (key && quantity != undefined) {
        this._setLoadingState(true)
        try {
          if (bundleId && bundleQuantityAfterChange < this.bundleMinimum) {
            for (let bundle of bundleItems) {
              const res = await shopifyCart.change(0, bundle.key)
            }
          } else {
            await shopifyCart.change(quantity, key)
          }

          await this._setCart()
        } catch (e) {
          console.log(e)
        }
        this._setLoadingState(false)
      }
    })
  }

  _setLoadingState(state) {
    const el = this.shadowRoot.querySelector('.cart-drawer')
    if (this.main) {
      const products = this.shadowRoot.querySelector('.cart-drawer_products')
      const loadingEl = this.shadowRoot.querySelector('.cart-drawer[main="true"] .loading-container')
      const height = products.offsetHeight
      loadingEl.style.height = height + 'px'
    }
    el.setAttribute('loading', state)
  }

  _renderComparePrice(comparePrice, quantity) {
    if (comparePrice) {
      return html` <s class="compare-price">$${centsToDollars(comparePrice * quantity)}</s> `
    }
  }

  _renderPrices(price, discountedPrice, comparePrice, quantity) {
    if (discountedPrice < price) {
      return html`
        <s class="compare-price">$${centsToDollars(price)}</s>
        <div class="font-bold">$${centsToDollars(discountedPrice)}</div>
      `
    } else {
      return html`
        ${this._renderComparePrice(comparePrice, quantity)}
        <div class="font-bold">$${centsToDollars(price)}</div>
      `
    }
  }

  _variantTitle(variantTitle, productTitle) {
    variantTitle = productTitle ? variantTitle.replace(`${productTitle} /`, '') : variantTitle
    if (variantTitle) {
      return html`${variantTitle.replace(/ \//g, ',')}`
    }
  }

  _calcIndividualPrice(packSize, sizeUnit, price, discountedPrice, comparePrice, quantity) {
    let packNum = parseInt(packSize)
    let totalPacks = packNum * quantity
    if (packSize && packSize > 1 && sizeUnit) {
      if (discountedPrice < price) {
        return html`
          &nbsp;/&nbsp;
          <div class="flex">
            <s>$${centsToDollars(price / totalPacks)}</s>
            <span style="margin-left:5px;">$${centsToDollars(discountedPrice / totalPacks)} per ${sizeUnit}</span>
          </div>
        `
      } else if (comparePrice) {
        return html`
          &nbsp;/&nbsp;
          <div class="flex">
            <s>$${centsToDollars(comparePrice / totalPacks)}</s>
            <span style="margin-left:5px;">$${centsToDollars(price / totalPacks)} per ${sizeUnit}</span>
          </div>
        `
      } else {
        return html`&nbsp;/&nbsp; $${centsToDollars(price / totalPacks)} per ${sizeUnit}`
      }
    }
  }

  _renderSubscription(properties, item) {
    if (properties?.is_subscription) {
      const frequency = parseInt(properties?.shipping_interval_frequency)
      const unit = properties?.shipping_interval_unit_type
      return html`
        <div class="cart-item-subscription">Delivers every ${frequency > 1 ? `${frequency} ${unit}s` : unit}</div>
      `
    }
  }

  _buildCartItems() {
    if (this.count > 0 && this.cartItems) {
      return html`
        ${this.cartItems.map((item) => {
          return html`
            <li class="cart-item">
              <div role="group" aria-label="product" class="flex cart-item_border">
                <div class="left">
                  <img
                    class="cart-item_image"
                    src="${resizeImageSrc(item.featured_image.url, 194)}"
                    width="194"
                    height="191"
                    alt="${item?.product_title} product"
                  />
                  <div class="flex">
                    <div class="quantity-selector flex">
                      <button
                        class="flex-1"
                        @click=${() => this._changeQuantity(item.key, (item.quantity -= 1), item)}
                        aria-label="Remove 1 ${item?.product_title} from cart"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        min="1"
                        max="99"
                        value=${item.quantity}
                        readonly
                        aria-label="total quantity of ${item?.product_title} in cart"
                      />
                      <button
                        class="flex-1"
                        @click=${() => this._changeQuantity(item.key, (item.quantity += 1), item)}
                        aria-label="Add 1 ${item?.product_title} to cart"
                      >
                        +
                      </button>
                    </div>
                    <button
                      class="remove-btn"
                      aria-label="Remove ${item?.product_title} from cart"
                      @click=${() => this._changeQuantity(item.key, 0, item)}
                    >
                      <img class="remove-btn_icon" src="${this.assets}_icon-cart-remove.svg" alt="remove icon" />
                    </button>
                  </div>
                </div>
                <div class="right flex flex-col justify-between">
                  <div class="flex justify-between gap-1">
                    <div class="flex flex-col gap-1">
                      <h4 class="title">${item.product_title}</h4>
                      <div class="type">${item.type}</div>
                      <div class="variant-title">${item?.variant_options[1]}</div>
                      ${item.properties?.bundle_id ? html`<div class="bundle">Bundle</div>` : ''}
                    </div>
                    <div>
                      ${this._renderPrices(
                        item.original_line_price,
                        item.final_line_price,
                        item.compare_at_price,
                        item.quantity
                      )}
                    </div>
                  </div>
                  ${this._renderSubscription(item.properties, item)}
                </div>
              </div>
            </li>
          `
        })}
      `
    } else {
      return html`
        <div class="empty-cart">
          <div class="empty-cart_details">
            <p class="empty-cart_text">${this.empty_cart.text}</p>
            <button
              class="btn-primary"
              role="link"
              aria-label="${this.empty_cart.link_name}"
              onclick="window.location.href='${this.empty_cart.link}'"
            >
              ${this.empty_cart.link_name}
            </button>
          </div>
        </div>
      `
    }
  }

  updated() {
    window.MicroBus.emit('side-cart:updated', { id: 'side-cart' })
  }

  _discountInputHandler() {
    let input = this.shadowRoot.querySelector('.js-discount-code-form > input')
    let code = input.value
    if (this.discountCode && this.discountCode !== code) {
      this.shadowRoot.querySelector('.js-discount-code-form').classList.remove('discount-applied')
      this.discountCode = ''
      localStorage.removeItem('_discount_code')
      this.totalSavings = centsToDollars(this.ogTotalSavings)
      this.subtotal = centsToDollars(this.ogSubtotal)
    }
    if (code) {
      input.classList.add('input-active')
    } else {
      input.classList.remove('input-active')
    }
  }

  async _handleDiscountCode(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    this.discountLoading = true
    let code = this.shadowRoot.querySelector('.js-discount-code-form > div > input')?.value.trim()
    let res = false
    if (this.hasSubscription) {
      res = await this._getDiscount(code)
    } else {
      res = await this.applyDiscount(code)
    }
    this._setDiscountCodeInfo(res, code)
  }

  async _getDiscount(code) {
    let url = this._getCheckout(code)
    return get(url)
  }

  async applyDiscount(code) {
    const payRes = await fetch('/payments/config').then((res) => res.json())
    const checkout_json_url = '/wallets/checkouts/'
    const authorization_token = window.btoa(payRes.paymentInstruments.accessToken)
    let body = {
      checkout: {
        country: Shopify.country,
        discount_code: code,
        line_items: this.cartItems,
        presentment_currency: Shopify.currency.active,
      },
    }
    const data = await fetch(checkout_json_url, {
      headers: {
        accept: '*/*',
        'cache-control': 'no-cache',
        authorization: 'Basic ' + authorization_token,
        'content-type': 'application/json, text/javascript',
        pragma: 'no-cache',
        'sec-fetch-dest': 'empty',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin',
      },
      referrerPolicy: 'strict-origin-when-cross-origin',
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(body),
    }).then((res) => res.json())

    if (data.checkout && data.checkout.applied_discounts.length > 0) {
      let discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkout/'
      fetch(discountApplyUrl).then((res) => res.text())
      return data.checkout
    } else {
      fetch('/checkout?discount=%20')
      return false
    }
  }

  async _setDiscountCodeInfo(res, code = this.discountCode) {
    this.discountCodeError = false
    if (this.hasSubscription) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(res, 'text/html')
      let discountAmount = doc?.querySelector('#discount_amount')?.innerText
      let discountValid = discountAmount != '' || parseInt(discountAmount) * 100 > 0 ? true : false
      if (discountValid) {
        this.discountCodeTotal = doc?.querySelector('#subtotal_amount')?.innerText
      } else {
        this.discountCodeError =
          'Discount code is not valid or only applies to one time products. Please try code on checkout page.'
      }
    } else {
      if (res && res?.applied_discounts?.length > 0) {
        this.discountCodeTotal = res?.total_price ?? 0
        const lineItems = res?.line_items ?? []
        const hasDiscounts = lineItems?.filter((item) => item?.discount_allocations?.length > 0)
        const temp = [...this.cartItems]
        hasDiscounts.forEach((item) => {
          const index = temp.findIndex((el) => el.variant_id === item.variant_id)
          const discount_amount = parseFloat(item.discount_allocations[0].amount?.replace('$', '').trim()) * 100
          const new_final_line_price = temp[index].final_line_price - discount_amount
          temp[index].final_line_price = new_final_line_price
        })
        this.cartItems = temp
      } else {
        this.discountCodeError = 'Discount code is not valid. Please try code on checkout page.'
      }
    }
    this.discountLoading = false
    if (!this.discountCodeError) {
      this.discountCodeTotal = parseFloat(this.discountCodeTotal.replace('$', '').trim()) * 100
      this.discountCodeSavings = this.ogSubtotal - this.discountCodeTotal
      this.subtotal = centsToDollars(this.discountCodeTotal)
      this.totalSavings = centsToDollars(this.ogTotalSavings + this.discountCodeSavings)
      this.discountCode = code
      this.discountCodeType = res?.applied_discount?.value_type
      this.discountCodeValue = res?.applied_discount?.value
      localStorage.setItem('_discount_code', code.toUpperCase())
    } else {
      this.subtotal = centsToDollars(this.ogSubtotal)
      this.totalSavings = centsToDollars(this.ogTotalSavings)
      this.discountCode = null
      localStorage.removeItem('_discount_code')
      alert(this.discountCodeError)
    }
  }

  _getFreeShippingMin() {
    const defaultFreeShippingMin = 75
    if (this.discountCodeType === 'shipping' && this.discountCodeValue) {
      const discountCodeValue = parseInt(this.discountCodeValue) / 100
      return defaultFreeShippingMin - defaultFreeShippingMin * discountCodeValue
    }

    return defaultFreeShippingMin
  }

  _renderTotalSavings(totalSavings) {
    if (totalSavings > 0) {
      return html`
        <div class="flex justify-between margin-t-xs">
          <div>Total Savings</div>
          <div>-$${totalSavings}</div>
        </div>
      `
    }
  }
  _renderDiscountCode() {
    if (this.discountCodeEnabled) {
      return html`
        <div
          class="flex align-center discount-code-form js-discount-code-form ${this.discountCode ? `discount-applied` : ``}"
          style="gap: 10px"
        >
          <div class="relative">
            <input
              type="text"
              placeholder="Enter Coupon Code"
              value="${ifDefined(this.discountCode)}"
              @keyup=${this._discountInputHandler}
              id="enter-coupon-code"
              required
            />
            <label for="enter-coupon-code">Coupon Code (required)</label>
          </div>
          <button @click=${this._handleDiscountCode} data-loading="${ifDefined(this.discountLoading)}">
            <span class="apply-text">Apply</span><span class="applied-text">Applied</span>
            <svg
              width="38"
              height="38"
              viewBox="0 0 38 38"
              xmlns="http://www.w3.org/2000/svg"
              aria-labelledby="loadingSpinnerIconTitle"
            >
              <title id="loadingSpinnerIconTitle">Loading Spinner Icon</title>
              <defs>
                <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                  <stop stop-color="currentColor" stop-opacity="0" offset="0%" />
                  <stop stop-color="currentColor" stop-opacity=".631" offset="63.146%" />
                  <stop stop-color="currentColor" offset="100%" />
                </linearGradient>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)">
                  <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="0.9s"
                      repeatCount="indefinite"
                    />
                  </path>
                  <circle fill="#000" cx="36" cy="18" r="1">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="0.9s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </g>
              </g>
            </svg>
          </button>
        </div>
      `
    }
  }

  _renderUpsells() {
    if (this.upsells.length > 0) {
      return html`
        <div class="cart-drawer_upsells">
          <h3>
            <div class="side-cart-upsell-card-header">You might also like</div>
          </h3>
          <ul class="side-cart-upsell-products">
            ${this.upsells.map((product, i) => {
              let badgeText = ''
              product.tags.map((tag) => {
                switch (tag.toLowerCase()) {
                  case '$ donated for every purchase':
                    badgeText = html`<div class="side-cart-upsell-badge-text">Donation</div>`
                    break
                  case 'best sellers':
                    badgeText = html`<div class="side-cart-upsell-badge-text">Best Seller</div>`
                    break
                  case 'hu x rethink food':
                    badgeText = html`<div class="side-cart-upsell-badge-text">Rethink</div>`
                    break
                  case 'limited quantity':
                    badgeText = html`<div class="side-cart-upsell-badge-text">Limited Quantity</div>`
                    break
                  case 'new item':
                    badgeText = html`<div class="side-cart-upsell-badge-text">New Item</div>`
                }
              })
              return html`
                <li class="side-cart-upsell-card" data-position=${++i}>
                  <div class="side-cart-upsell-card-image-container">
                    <img
                      src="${resizeImageSrc(product.featured_image, 300)}"
                      alt="${product.title} product"
                      width="110"
                      height="110"
                      loading="lazy"
                    />
                    ${badgeText}
                  </div>
                  <div class="side-cart-upsell-card-details">
                    <div>
                      <div class="side-cart-upsell-card-title">${product.title}</div>
                      <div class="side-cart-upsell-card-category">${product.type}</div>
                      <div class="side-cart-upsell-card-price">${product?.options[1]?.values[0]}</div>
                    </div>
                    <add-button
                      data-toggle="false"
                      variant-id="${product.variants[0].id}"
                      @click=${(e) => {
                        e.preventDefault()
                        this._sendUpsellEvent(product, i)
                      }}
                    >
                      <button>ADD - $${centsToDollars(product.price)}</button>
                    </add-button>
                  </div>
                </li>
              `
            })}
          </ul>
        </div>
      `
    }
  }

  _sendUpsellEvent(product, position) {
    if (window?.gtag) {
      gtag('event', `In Cart - Upsell Added`, {
        event_detail: `${product.title} - ${position}`,
      })
    }
  }

  _renderGiftNote() {
    const giftNoteText = this.isGiftNote ? 'Edit' : 'Add a free gift note →'
    if (this.giftNoteEnabled) {
      return html` <div class="justify-between add-gift-note-wrapper" ?gift-note-active="${this.isGiftNote}">
        ${this.isGiftNote ? html`<div>✓ Gift note added</div>` : ''}
        <side-drawer-btn for="side-cart-gift-note" class="flex items-center" style="color: #231F20;"
          ><span style="color: #231F20;">${giftNoteText}</span></side-drawer-btn
        >
      </div>`
    }
  }

  _renderCartBottom() {
    let contShopping = ``
    if (this.main) {
      contShopping = html`
        <div class="continue-shopping">
          <a href="/"> Continue Shopping </a>
        </div>
      `
    }
    const strikeoutSubtotal =
      this.ogSubtotal > this.subtotal &&
      this.discountCode &&
      this.discountCodeTotal &&
      this.ogSubtotal !== this.discountCodeTotal
        ? html`<s style="color: #6e6e73; font-weight: 500;">$${centsToDollars(this.ogSubtotal)}</s>&nbsp;`
        : ``
    if (this.count > 0 && this.cartItems) {
      return html`
        <div>
          ${this._renderGiftNote()}
          <div class="cart-drawer_bottom">
            ${this._renderDiscountCode()}
            <div class="flex justify-between order-total">
              <h4>Subtotal</h4>
              <div>${strikeoutSubtotal} $${this.subtotal}</div>
            </div>
            <button class="btn-primary mt-4 text-xs" id="checkout" name="checkout" @click=${this._goToCheckout}>
              Checkout
            </button>
            ${this._renderAdditionalCheckoutButtons()}
          </div>
        </div>
      `
    }
  }

  _renderAdditionalCheckoutButtons() {
    if (!this.hasSubscription) {
      return html` <slot name="additionalCheckout"></slot> `
    }

    return null
  }

  _getCheckout(discount = this.discountCode) {
    return '/checkout?discount=' + discount
  }

  _goToCheckout() {
    window.location = this._getCheckout()
  }

  _renderCartBody() {
    if (this.main) {
      const isEmpty = this.count === 0 ? 'is-empty' : ''
      return html`
        <div class="cart-drawer_body ${isEmpty}">
          <div class="cart-drawer_products-wrap relative">
            <ul class="cart-drawer_products">
              ${this._buildCartItems()}
            </ul>
            <div class="cart-scroll-blur"></div>
          </div>
          <div class="cart-drawer_details">${this._renderCartBottom()}</div>
        </div>
      `
    } else {
      const isEmpty = this.count === 0 ? 'is-empty' : ''
      return html`
        <div class="cart-drawer_products-container">
            <div class="loading-container">
              <img class="loading-spinner" width="50" height="50" src="${
                this.assets
              }_icon-loading-tail-spin.svg" alt="loading spinner icon" />
            </div>
          <div class="cart-drawer_products-line-container relative">

            <ul class="cart-drawer_products ${isEmpty}">
              ${this._buildCartItems()}
            </ul>
            <div class="cart-drawer_upsells-container ${isEmpty}">
              ${this._renderUpsells()}
            </div>
          </div>

          </div>
          <div>${this._renderCartBottom()}</div>
        </div>
      `
    }
  }

  _renderCartCount() {
    if (this.count > 0) {
      return html`<p class="cart-drawer_cart-count">(${this.count} ${this.itemsText})</p>`
    }
  }

  render() {
    return html`
      <div class="cart-drawer tailwind" loading="false" main=${this.main}>
        <div class="cart-drawer_header">
          <div class="cart-drawer_header-details">
            <h3 class="cart-drawer_title">Your Cart</h3>
            ${this._renderCartCount()}
          </div>
          <free-shipping-progress
            .subtotal=${this.subtotal}
            free-shipping-min="${this._getFreeShippingMin()}"
          ></free-shipping-progress>
        </div>
        ${this._renderCartBody()}
      </div>
    `
  }

  _changeQuantity(key, quantity = 0, item = null) {
    window.MicroBus.emit('cart:change-quantity', { key: key, quantity: quantity, item: item })
  }
}

customElements.define('cart-drawer', CartDrawer)
